<template>
    <div class="login">
        <!-- <img src="../assets/login.jpg" alt="" /> -->
    </div>

</template>

<script>
import { getAccessToken, getTicket } from "../utils/api";
import axios from "axios";
import dd from "dingtalk-jsapi";
import { getLocalAk, getLocalSecret, getLocalAccessToken, getLocalUserToken } from '../utils/commonFunc';
export default {
  components: {},
  props: {},
  data() {
    return {
      code: "",
      realMenuData: [],
      isHaveParam:false,
      urlParams:{},
      url:''
    };
  },
  watch: {},
  computed: {},
  methods: {
    initMenu(data){
      // console.log(data,'datatata');
      var houtaishuju = data
      var menuData = this.$store.state.menuData
      this.realMenuData = []
      menuData.forEach((item)=>{
        houtaishuju.forEach(val=>{
          if(item.label==val.label){
            var obj = {
              label:item.label,
              index:item.index,
              children:[]
            }
            item.children.forEach(temp=>{
              if(val.children.indexOf(temp.label)!==-1){
                obj.children.push(temp)
              }
            })
            this.realMenuData.push(obj)
          }
        })
      })
      // console.log(this.realMenuData,'this.realMenuData');
     localStorage.setItem('menu',JSON.stringify(this.realMenuData))
    },
    getAuth(){
      // console.log(localStorage.getItem('url'),'localStorage.getItem(url2222222222)');
      var param = {
        url: localStorage.getItem('url')
      }
      getTicket(param)
        .then(res=>{
            console.log(res,'getTicket');
            if(res.message.status == 'success'){
              // console.log(res.data.param,'res.data.param11111111111');
                localStorage.setItem('configData',JSON.stringify(res.data.param)) //将请求返回的数据进行本地缓存
                this.$storage.set('ticket',res.data.ticket,7200000) //将ticket进行缓存
            }else{
              // this.$message.error(res.message.text)
              console.log(res.message.text);
            }
        })
        .catch(err=>{
          console.log(err,'err');
        })
    },
    ddEvent() {
      var that = this;
      dd.ready(function () {
        dd.runtime.permission.requestAuthCode({
          corpId: "ding2c7e12ec92b333ec35c2f4657eb6378f", // 企业id
          onSuccess: (info) => {
            that.code = info.code; // 通过该免登授权码可以获取用户身份
            that.getAccess();
          },
          onFail: function (err) {
            console.log(err, "err");
          },
        });
      });
    },
    getAccess() {
      let that = this;
      var params = {
        ak: localStorage.getItem('ak'),
        secret: localStorage.getItem('secret'),
      };
      getAccessToken(params)
        .then((res1) => {
          // console.log(res1,'res1');
          if (res1.message.status == "success") {
            localStorage.setItem("access_token", res1.data.access_token);
            that.$message.success('正在核对您的信息，请稍等')
            axios.post("/open/api/v1/dingtalk/atomic/login?access_token=" + res1.data.access_token,{ code: that.code })
              .then((res2) => {
                console.log(res2, "user_token");
                if (res2.data.message.status == "success") {
                  // console.log(res2.data.data.user_token, "user_token");
                  localStorage.setItem("user_token", res2.data.data.user_token);
                  that.$store.commit(
                    "changeUserToen",
                    res2.data.data.user_token
                  );
                  that.getAuth();
                  // console.log(res2.data.data, "查看数据");
                  var power = res2.data.data.power.group.length == 0?[]:JSON.parse(res2.data.data.power.group[0].power);
                  var worker = res2.data.data.worker
                  var user = res2.data.data.power.user == false?[]:JSON.parse(res2.data.data.power.user.power);
                  localStorage.setItem('name',res2.data.data.worker.name)
                  localStorage.setItem('worker',JSON.stringify(res2.data.data.worker))
                  // console.log(power,'power');
                  // console.log(worker,'worker');
                  // console.log(user,'user');
                  if(worker.admin == 1 || worker.boss == 1){
                      that.$message.success("身份验证成功");
                      localStorage.setItem('menu',JSON.stringify(that.$store.state.menuData))
                      // console.log(JSON.parse(localStorage.getItem('menu')),'JSON.parse(localStorage.getItem(menu))');
                      // console.log(JSON.parse(localStorage.getItem('menu')),'boss的权限');
                      that.$router.push({ name: JSON.parse(localStorage.getItem('menu'))[0].children[0].name})
                  }else{
                    if(user.length !== 0){
                      that.initMenu(user)
                      that.$message.success("身份验证成功");
                      // console.log(JSON.parse(localStorage.getItem('menu')),'user的权限');
                      that.$router.push({ name: JSON.parse(localStorage.getItem('menu'))[0].children[0].name})
                    }else{
                        if (power.length !== 0) {
                          // that.$store.commit("setPower", {data: res2.data.data.power.group[0]});
                          that.initMenu(power)
                          that.$message.success("身份验证成功");
                          // console.log(JSON.parse(localStorage.getItem('menu')),'角色的权限');
                          that.$router.push({ name: JSON.parse(localStorage.getItem('menu'))[0].children[0].name})
                        } else {
                          if(power.length == 0){
                            that.initMenu(power);
                          }
                          // that.$message.error("您当前没有访问权限，请联系管理员");
                      }
                    }
                  }
                  // 判断有无参数 
                  if(that.isHaveParam){
                    if(that.urlParams.type === 1 || that.urlParams.type === 2){
                      return that.$router.push('/orderDetail/orderDetail?jumpId='+(that.urlParams.id))
                    }else if(that.urlParams.type === 3){
                      return that.$router.replace('/phoneDetail?jumpId='+(that.urlParams.id))
                    }
                  }
                  
                }else{
                  // that.$message.error(res2.data.message.text)
                  console.log(res2.data.message.text);
                }
              })
              .catch((err) => {
                console.log(err, "err");
              });
          }else{
            // that.$message.error(res1.message.text)
            console.log(res1.message.text);
          }
        })
        .catch((err) => {
          console.log(err, "err");
        });
      // loading.close();
    },
    setUserToken() {
      var that = this
      that.$message.success("身份验证成功");
      if(that.$storage.get('ticket') == null){
        that.getAuth()
      }
     
      // that.$router.push({ name: that.$store.state.menuData[0].children[0].name})
      // console.log(localStorage.getItem('menu').length,'localStorage.getItem(menu).length');
      // console.log(localStorage.getItem('menu'),'2222222222222222222');
      // console.log(localStorage.getItem('menu') == false,'33333333333333333');
      if(localStorage.getItem('menu') == '' || localStorage.getItem('menu') == undefined || localStorage.getItem('menu') == null ||localStorage.getItem('menu').length == 2){
        // console.log('进来了1');
        that.ddEvent()
      }else{
        // console.log('进来了2');
        that.$router.push({ name: JSON.parse(localStorage.getItem('menu'))[0].children[0].name})
      }

      // 判断有无参数 
      if(that.isHaveParam){
        if(that.urlParams.type === 1 || that.urlParams.type === 2){
          return that.$router.push('/orderDetail/orderDetail?jumpId='+(that.urlParams.id))
        }else if(that.urlParams.type === 3){
          return that.$router.replace('/phoneDetail?jumpId='+(that.urlParams.id))
        }
      }
    },

    initEvent(){
        var reg = new RegExp('#/','g')
        // console.log(window.location.href.replace(reg,''),'reg更改打印');
        if( localStorage.getItem('url') == null || localStorage.getItem('url') == undefined ||  localStorage.getItem('url') !== window.location.href.replace(reg,'') ){
          // console.log(window.location.href,'window.location.href进来了');
          var url = window.location.href;
          var urlHerf = url.replace(reg,'')
          localStorage.setItem('url',urlHerf)
          this.getAuth()
        }
    }
    
  },
  created() {},
  mounted() {
    // console.log('xxxxxxxxxx');
    // let access_token = getLocalAccessToken(getLocalAk(), getLocalSecret());
    // console.log(access_token, 'xx2xx');
    //此处用于替换原有登录逻辑
    //登录流程：
    //1、检查本次启动是否指向一个内部页面，通过判断是否包含target、type、id参数进行判断
    var locationUrl = window.location.href
    var locationUrl = window.location.href
    var arr = locationUrl.split('/')
    var urlArr = arr[2]
    if(urlArr == 'web.wo.dd.dev.ebyte.com'){
        axios.defaults.baseURL = 'https://dev.ebyte.com'
        localStorage.setItem('uploadUrl','https://dev.ebyte.com/open/api/v1/attach/uploader?user_token=')
        localStorage.setItem('secret','cd/OYGOHAB26ESEje8.enmtWBI6KcVZygFqtFJ.7jgMIXj78LLq')
        localStorage.setItem('ak','570aa8918a20da4dce1a84959f6237c6')
    }else if(urlArr == 'web.wo.dd.cloud.ebyte.com'){
        axios.defaults.baseURL =  'https://cloud.ebyte.com'
        localStorage.setItem('uploadUrl','https://cloud.ebyte.com/open/api/v1/attach/uploader?user_token=')
        localStorage.setItem('secret','zU7tIoV.enxCjncnOU3.0xvX3DJrVsTZDdxHqtkVBjFs5hfiWgO')
        localStorage.setItem('ak','17be0ce1f1ddc9cecfadc0b6d6161b63')
    }

    // localStorage.setItem("user_token", 'fbe0959ee6bb0148c67e709a4974449a');
    // localStorage.setItem('menu',JSON.stringify(this.$store.state.menuData))
    // localStorage.setItem("name", '主管理员/王宏达');
    
    // this.$storage.remove('user_token')
    // this.$storage.remove('ticket')

 
    var url = window.location.href;
    var urlArr = url.split('?')
    var userToken = localStorage.getItem('user_token')
    console.log(urlArr.length,'urlArr.length');
    if(urlArr.length == 2){
        this.isHaveParam = true
        var str = urlArr[1].replace('#','')
        str = str.replace('/','')
        var parameterArr = str.split('&')
        parameterArr.forEach(item=>{
            var  items= item.split('=')
            if(items[0] == 'target'){
                this.urlParams.target = Number(items[1])
            }else if(items[0] == 'type'){
                this.urlParams.type = Number(items[1])
            }else if(items[0] == 'id'){
                this.urlParams.id = Number(items[1])
            }
        })
    }else if(urlArr.length == 1){
      this.isHaveParam = false
    }

    this.initEvent();

    console.log(userToken,'userToken');
    //登录
    if(userToken == null || userToken === '' || userToken == undefined || this.$storage.get('ticket') == null ){
        console.log('直接走登录流程');
        this.ddEvent()
    }else{
      console.log('已经有了token,直接跳过登录流程www');
      this.setUserToken()
    }
  },
};
</script>
<style lang="scss" scoped>
.login {
  width: 100%;
  height: 100vh;
}
</style>